import { render } from "./MenuAdd.vue?vue&type=template&id=756b9bf6"
import script from "./MenuAdd.vue?vue&type=script&lang=js"
export * from "./MenuAdd.vue?vue&type=script&lang=js"

import exportComponent from "D:\\programmazione\\pronails\\MemsionPrivato\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__